export default __webpack_public_path__ + "a41194734c8ac21e999b8eed883864f6.png";